export const actionTypes = {
  MODIFY_SELECTED_USER: "MODIFY_SELECTED_USER",
  USERS_REQUEST: "USERS_REQUEST",
  USERS_REQUEST_SUCCESS: "USERS_REQUEST_SUCCESS",
  USERS_REQUEST_FAILURE: "USERS_REQUEST_FAILURE",
  USERS_ACCOUNT_REQUEST: "USERS_ACCOUNT_REQUEST",
  USERS_ACCOUNT_REQUEST_SUCCESS: "USERS_ACCOUNT_REQUEST_SUCCESS",
  USERS_ACCOUNT_REQUEST_FAILURE: "USERS_ACCOUNT_REQUEST_FAILURE",
  USERS_ENTITLEMENT_REQUEST: "USERS_ENTITLEMENT_REQUEST",
  USERS_ENTITLEMENT_REQUEST_SUCCESS: "USERS_ENTITLEMENT_REQUEST_SUCCESS",
  USERS_ENTITLEMENT_REQUEST_FAILURE: "USERS_ENTITLEMENT_REQUEST_FAILURE",
  SET_ENTITLEMENTS_BR_SELECTED: "SET_ENTITLEMENTS_BR_SELECTED",
  USER_RESET_STATE: "USER_RESET_STATE",
  ENTITLEMENTS_BR_SELECTED_RESET: "ENTITLEMENTS_BR_SELECTED_RESET",

  GET_USER_MANAGERS: "GET_USER_MANAGERS",
  GET_USER_MANAGERS_SUCCESS: "GET_USER_MANAGERS_SUCCESS",
  GET_USER_MANAGERS_FAILURE: "GET_USER_MANAGERS_FAILURE",

  GET_USER_OUS: "GET_USER_OUS",
  GET_USER_OUS_SUCCESS: "GET_USER_OUS_SUCCESS",
  GET_USER_OUS_FAILURE: "GET_USER_OUS_FAILURE",
};

export const modifySelectedUser = (user: {}) => ({
  type: actionTypes.MODIFY_SELECTED_USER,
  user,
});

export const userManagersRequest = (payload: any) => ({
  type: actionTypes.GET_USER_MANAGERS,
  payload,
});
export const userManagersRequestSuccess = (payload: any) => ({
  type: actionTypes.GET_USER_MANAGERS_SUCCESS,
  payload,
});
export const userManagersRequestFailure = (err: any) => ({
  type: actionTypes.GET_USER_MANAGERS_FAILURE,
  err,
});
export const userOusRequest = (payload: any) => ({
  type: actionTypes.GET_USER_OUS,
  payload,
});
export const userOusRequestSuccess = (payload: any) => ({
  type: actionTypes.GET_USER_OUS_SUCCESS,
  payload,
});
export const userOusRequestFailure = (err: any) => ({
  type: actionTypes.GET_USER_OUS_FAILURE,
  err,
});

export const usersRequest = () => ({
  type: actionTypes.USERS_REQUEST,
});

export const usersRequestSuccess = (payload: any) => ({
  type: actionTypes.USERS_REQUEST_SUCCESS,
  payload,
});

export const usersRequestFailure = (err: any) => ({
  type: actionTypes.USERS_REQUEST_FAILURE,
  err,
});

export const usersAccountRequest = (userCode: string) => ({
  type: actionTypes.USERS_ACCOUNT_REQUEST,
  userCode,
});

export const usersAccountRequestSuccess = (payload: any) => ({
  type: actionTypes.USERS_ACCOUNT_REQUEST_SUCCESS,
  payload,
});

export const usersAccountRequestFailure = (err: any) => ({
  type: actionTypes.USERS_ACCOUNT_REQUEST_FAILURE,
  err,
});

export const usersEntitlementRequest = (userId: any[]) => ({
  type: actionTypes.USERS_ENTITLEMENT_REQUEST,
  userId,
});

export const usersEntitlementRequestSuccess = (payload: any) => ({
  type: actionTypes.USERS_ENTITLEMENT_REQUEST_SUCCESS,
  payload,
});

export const usersEntitlementRequestFailure = (err: any) => ({
  type: actionTypes.USERS_ENTITLEMENT_REQUEST_FAILURE,
  err,
});

export const setEntitlementsBRSelected = (payload: any) => ({
  type: actionTypes.SET_ENTITLEMENTS_BR_SELECTED,
  payload,
});

export const entitlementsListBusinessRolesSelectedReset = () => ({
  type: actionTypes.ENTITLEMENTS_BR_SELECTED_RESET,
});

export const userResetState = () => ({
  type: actionTypes.USER_RESET_STATE,
});
